import React from 'react';
import CalculatorContainer from './CalculatorContainer';

const Views = ({ handleRouteChange }) => {
  return <CalculatorContainer />;
};

export default Views;
